"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vkMarkets = void 0;
const vkMarkets = exports.vkMarkets = ['am', 'by', 'ee', 'ge', 'lv', 'lt', 'md', 'ru', 'kz', 'kg'];
